/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react'
import { useState, useEffect } from 'react'
import {
  IonRow, IonLabel, IonButton,
} from '@ionic/react'
import { Icon } from '@iconify/react'
import { Dropdown } from 'react-bootstrap'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SelectView } from '../maps/StyledContainers'

import { useJourneysData2 } from '../../hooks/journeys/useJourneysData2'

/**
 *  ===========================================
 *      JOURNEY MAP CONTROLS
 *  ===========================================
 */

const MapControls = () => {
  const {
    view, views, handleViewChange, startMB, startRoute, startJourney, startAirJourney, filters,
    showRouteForm, showTicket, showMbForm, showJourneyAuthorization, showJourneyForm, showEditJourney,
    showJourneyChoice, setShowAirTravelList, showBackToJourneysMapButton, drawJourneyHistories, drawJourneys,
    setShowJourneysList, setShowBackToJourneysMapButton, setShowMapFilterPopup,
  } = useJourneysData2()

  const [toggleAll, setToggleAll] = useState(Object.values(filters).findIndex((param) => !param) < 0)

  /* Dropdown handlers */
  const [show, setShow] = useState(false)

  const showAddButton = !showRouteForm && !showTicket && !showMbForm && !showJourneyAuthorization && !showJourneyForm && !showEditJourney && !showJourneyChoice

  /* Show/hide movement boxes */

  useEffect(() => {
    setToggleAll(Object.values(filters).findIndex((param) => !param) < 0)
  }, [filters])

  /* Toggle fitler dropdown handler */

  /* Filters for map filters button */

  /* Forms to fill */
  const formButtons = (
    <>
      <Dropdown.Item
        onClick={() => {
          startRoute()
        }}
      > Route
      </Dropdown.Item>
      <Dropdown.Item
        className='add-button-journeys'
        onClick={() => {
          startMB()
          setShowAirTravelList(false)
        }}
      > Restriction Zone
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => {
          startJourney()
          setShowAirTravelList(false)
        }}
      >Road Travel Request
      </Dropdown.Item>
      <Dropdown.Item
        onClick={() => {
          startAirJourney()
          setShowAirTravelList(false)
        }}
      >Air Travel Request
      </Dropdown.Item>
    </>
  )

  return (
    <IonRow
      style={{
        backgroundColor: '#FFFFFF',
        padding: '10px 30px',
        marginBottom: '10px',
        boxShadow: '0px 4px 4px 0px #00000040',
        position: 'relative',
        borderRadius: '5px',
      }}
      className='ion-align-items-center ion-justify-content-between'
    >
      <SelectView
        style={{
          padding: '10px 20px',
          borderRadius: '5px',
          color: 'white',
        }}
        value={view}
        onChange={(e) => handleViewChange(e.target.value)}
        className='desktop-insights-dropdown'
      >
        {
          views.map((val) => (
            <option key={val} value={val}>{val}</option>
          ))
        }
      </SelectView>
      {
        showBackToJourneysMapButton && (
          <>
            <IonRow>
              <IonButton
                id='add-air-journey-button'
                onClick={() => {
                  setShowJourneysList(false)
                  setShowBackToJourneysMapButton(false)
                  drawJourneys(true)
                  drawJourneyHistories(true)
                }}
                style={{
                  '--background': '#FFFFFF',
                  textTransform: 'none',
                  fontWeight: 'normal',
                }}
              >
                <Icon style={{ color: '#326771', fontSize: '1.3em' }} icon='icons8:angle-left' />
                <IonLabel style={{ color: '#326771', letterSpacing: '-0.02em', fontSize: '1.1em' }}>Back to Journeys Map</IonLabel>
              </IonButton>
            </IonRow>
          </>
        )
      }
      <IonRow class='ion-align-items-center'>
        <IonButton onClick={() => setShowMapFilterPopup(true)} style={{ '--background': '#326771' }}>Filters<Icon icon='fa:filter' /></IonButton>
        {
          showAddButton && (
          <Dropdown>
            <Dropdown.Toggle style={{ backgroundColor: '#0C9500' }} className='map-button remove-arrow'> Add <FontAwesomeIcon icon={faPlus} /></Dropdown.Toggle>
            <Dropdown.Menu>
              {
                formButtons
              }
            </Dropdown.Menu>
          </Dropdown>
          )
        }
      </IonRow>
    </IonRow>
  )
}

export default MapControls
